module.exports = __webpack_public_path__ + "img/payment-portal-two.423da61e.png";